module.exports = __webpack_public_path__ + "images/ae91df9.png";